import { upperFirst, camelCase } from "lodash";

const blockNameTransform = (name) => {
    let type, block;
    [type, block] = name.split("/");
    type = upperFirst(type);
    block = upperFirst(camelCase(block));

    return `${type}${block}Block`;
};

export default blockNameTransform;
